import { useState } from 'react'
import ReactGA from 'react-ga4'
export const AllCharacteres = () => {
    const [hover, setHover] = useState(false)
    const [isVoiceOn, setIsVoiceOn] = useState(false)

    const [voice, setVoice] = useState(1)
    const setCurrent = (e) => {
        setVoice(e)
    }
    const [showModal, setShowModal] = useState(false)
    const [activeCharTab, setActiveCharTab] = useState('characters')
    const [modalImage, setModalImage] = useState()
    const handleOpenModal = (imagepath) => {
        setModalImage(imagepath)
        setShowModal(true)
    }
    const handleCloseModal = () => {
        setShowModal(false)
    }

    const chardata = [
        {
            name: 'Marona',
            bio: (
                <>
                    <p className='font-kiwi text-pbbrown text-shadow-white font-bold text-sub md:text-sm lg:text-base'>
                        A girl with the unusual power to interact with the souls of{' '}
                        <span className='text-pborange'>the dead</span>. Because of this power, she was once despised
                        and called <span className='text-pborange'>“The Possessed One”</span> by those around her.
                        However, she's now treated as a <span className='text-pborange'>hero</span> after saving the
                        world from Sulphur, the Lord of Terror. She is cheerful, optimistic, and kind, and works hard as
                        a <span className='text-pborange'>Chroma</span> to help solve people's problems.
                    </p>{' '}
                </>
            ),
            caption: (
                <p
                    className={`font-humming text-shadow-white font-bold text-[#57912c] text-sm md:text-base lg:text-lg -rotate-6`}
                >
                    "Chartreuse Gale!"
                </p>
            ),
            color: '#57912c',
        },
        {
            name: 'Ash',
            bio: (
                <>
                    <p className='font-kiwi text-pbbrown text-shadow-white font-bold text-sub md:text-sm lg:text-base'>
                        <span className='text-pborange'>A young Phantom </span>man who has acted as Marona's guardian
                        and partner ever since her parents passed away when she was young. He's kind, and has a strong
                        sense of justice. Ash becomes <span className='text-pborange'>separated</span> from Marona while
                        protecting her from the mysterious Shipwreck Fleet.
                    </p>{' '}
                </>
            ),
            caption: (
                <p
                    className={`font-humming text-shadow-white font-bold text-[#192f57] text-sm md:text-base lg:text-lg -rotate-6`}
                >
                    "For her sake, I will not fail!"
                </p>
            ),

            color: '#192f57',
        },
        {
            name: 'Apricot',
            bio: (
                <>
                    <p className='font-kiwi text-pbbrown text-shadow-white font-bold text-sub md:text-sm lg:text-base'>
                        A lonely <span className='text-pborange'>Phantom girl</span> Marona encounters when she finds
                        herself at Skullrock Island. Her swordsmanship, which she learned from her heroic pirate father,
                        is unmatched. However, due to
                        <span className='text-pborange'> not being able to speak with anyone</span> for many years, she
                        is extremely timid. Encouraged by the optimistic Marona, she decides to search for her{' '}
                        <span className='text-pborange'>lost father</span> and{' '}
                        <span className='text-pborange'>revitalize his pirate crew</span>.
                    </p>{' '}
                </>
            ),
            caption: (
                <p
                    className={`font-humming text-shadow-white font-bold text-[#c22b52] text-sm md:text-base lg:text-lg -rotate-6`}
                >
                    "Somebody, help this girl! Please!!!"
                </p>
            ),
            color: '#c22b52',
        },
        {
            name: 'Rouen',
            bio: (
                <>
                    <p className='font-kiwi text-pbbrown text-shadow-white font-bold text-sub md:text-sm lg:text-base'>
                        A beastman who was the{' '}
                        <span className='text-pborange'>first mate of the Argento Pirate Crew</span> and the{' '}
                        <span className='text-pborange'>right-hand wolfman</span> of the leader of the fleet, Apricot's
                        father. While he always acts listless and nihilistic,{' '}
                        <span className='text-pborange'>he is actually kind</span>. He shows an almost overprotective
                        parent sentiment towards Apricot, who he calls “Princess,” while still managing to get some digs
                        in all the while taking care of her. Five years prior to the events of the game, he tried to
                        protect Apricot and the others when they encountered the Shipwreck Fleet, but failed. As a
                        result, they lost their lives.
                    </p>{' '}
                </>
            ),
            caption: (
                <p
                    className={`font-humming text-shadow-white font-bold text-[#4879a6] text-sm md:text-base lg:text-lg -rotate-6`}
                >
                    "...Ugh, what a bunch of softies. Some pirates you are..."
                </p>
            ),

            color: '#4879a6',
        },
        {
            name: 'Henna',
            bio: (
                <>
                    <p className='font-kiwi text-pbbrown text-shadow-white font-bold text-sub md:text-sm lg:text-base'>
                        The Phantom of a <span className='text-pborange'>former Queen</span> of the Hasara Kingdom, an
                        island containing 70% sand. From times of old, it has been custom in Hasara for a woman to lead
                        the country. However, when she was young and inexperienced, she made{' '}
                        <span className='text-pborange'>bad political decisions</span> and lost her life in a{' '}
                        <span className='text-pborange'>coup d'etat</span>. Afterwards, she appeared as a Phantom in the
                        Hasara Kingdom, where she controls others with a bewitching power that turns them into her
                        servants. She opposes the current queen, who is her
                        <span className='text-pborange'> biological younger sister</span>.
                    </p>{' '}
                </>
            ),
            caption: (
                <p
                    className={`font-humming text-shadow-white font-bold text-sm md:text-base lg:text-lg -rotate-6 text-[#7b5f1b]`}
                >
                    "I shall take your eyes—your hearts—your lives! Power of charm, Opera Mauve!"
                </p>
            ),

            color: '#7b5f1b',
        },
        {
            name: 'Urumi',
            bio: (
                <>
                    <p className='font-kiwi text-pbbrown text-shadow-white font-bold text-sub md:text-sm lg:text-base'>
                        A phantom boy who lives on Snowfall Island, an extremely cold, frozen place that is covered in
                        snow all year round. Since he passed away as a young boy many years ago, he has{' '}
                        <span className='text-pborange'>
                            gained the ability to manifest himself as well as control the climate around him
                        </span>
                        . In spite of his young appearance, he is extremely powerful, and has caused many of the
                        island's inhabitants to perish by making the climate worse. Accordingly, he is called a{' '}
                        <span className='text-pborange'>“devil”</span> by the islanders who fear him.
                    </p>{' '}
                </>
            ),
            caption: (
                <p
                    className={`font-humming text-shadow-white font-bold text-[#787985] text-sm md:text-base lg:text-lg -rotate-6`}
                >
                    "Freeze! Freeze! Freeze! All of you, freeze!"
                </p>
            ),

            color: '#787985',
        },
        {
            name: 'Mayfair',
            bio: (
                <>
                    <p className='font-kiwi text-pbbrown text-shadow-white font-bold text-sub md:text-sm lg:text-base'>
                        The <span className='text-pborange'>big sister-like leader of a certain pirate group</span>. She
                        appears during Marona's adventure when Marona and her companions visit Versailles, an island
                        abundant with nature that is closed off to outsiders. There, she protects the island from
                        poachers. Once she gets her mind set on something, she charges ahead at full speed, and she{' '}
                        <span className='text-pborange'>values the swashbuckler's spirit and her family</span> over all
                        else. She calls her crew family, and is at times a tough trainer, while at others a gentle
                        protector.
                    </p>{' '}
                </>
            ),
            caption: (
                <p
                    className={`font-humming text-shadow-white font-bold text-sub md:text-base -rotate-6 text-[#B12A57]`}
                >
                    "My crew is my family. A true swashbuckler doesn't crush someone who saved their family."
                </p>
            ),

            color: '#B12A57',
        },
    ]
    return (
        <>
            <div className='w-full max-w-[1136px] mx-auto px-2 pt-12 md:pt-0'>
                <div className='relative mx-auto h-0 w-full pt-[58.8%]'>
                    <a
                        onClick={() => {
                            ReactGA.event({
                                action: 'click',
                                event: 'link',
                                category: 'Character',
                                label: 'Marona',
                            })
                        }}
                        href='#char-1'
                    >
                        <img
                            onMouseEnter={() => setHover(1)}
                            onMouseLeave={() => setHover(false)}
                            className='char1 hover:brightness-110 duration-300 cursor-pointer'
                            src={`${process.env.PUBLIC_URL}/images/characters/chr_nav_visual_01.png`}
                            alt='marona kv'
                        />{' '}
                    </a>
                    {hover === 1 && (
                        <img
                            className='hidden md:block charinfo-1'
                            src={`${process.env.PUBLIC_URL}/images/characters/marona-name.png`}
                            alt='comment bubble'
                        />
                    )}
                    <img
                        className='block md:hidden charinfo-1'
                        src={`${process.env.PUBLIC_URL}/images/characters/marona-name.png`}
                        alt='comment bubble'
                    />

                    <a
                        onClick={() => {
                            ReactGA.event({
                                action: 'click',
                                event: 'link',
                                category: 'Character',
                                label: 'Ash',
                            })
                        }}
                        href='#char-2'
                    >
                        <img
                            onMouseEnter={() => setHover(2)}
                            onMouseLeave={() => setHover(false)}
                            className='char2 hover:brightness-110 duration-300 cursor-pointer'
                            src={`${process.env.PUBLIC_URL}/images/characters/chr_nav_visual_02.png`}
                            alt='ash kv'
                        />{' '}
                    </a>
                    {hover === 2 && (
                        <img
                            className='hidden md:block charinfo-2'
                            src={`${process.env.PUBLIC_URL}/images/characters/ash-name.png`}
                            alt='comment bubble'
                        />
                    )}
                    <img
                        className='block md:hidden charinfo-2'
                        src={`${process.env.PUBLIC_URL}/images/characters/ash-name.png`}
                        alt='comment bubble'
                    />

                    <a
                        onClick={() => {
                            ReactGA.event({
                                action: 'click',
                                event: 'link',
                                category: 'Character',
                                label: 'Apricot',
                            })
                        }}
                        href='#char-3'
                    >
                        <img
                            onMouseEnter={() => setHover(3)}
                            onMouseLeave={() => setHover(false)}
                            className='char3 hover:brightness-110 duration-300 cursor-pointer'
                            src={`${process.env.PUBLIC_URL}/images/characters/chr_nav_visual_03.png`}
                            alt='apricot kv'
                        />
                    </a>
                    {hover === 3 && (
                        <img
                            className='hidden md:block charinfo-3'
                            src={`${process.env.PUBLIC_URL}/images/characters/apricot-name.png`}
                            alt='comment bubble'
                        />
                    )}
                    <img
                        className='block md:hidden charinfo-3'
                        src={`${process.env.PUBLIC_URL}/images/characters/apricot-name.png`}
                        alt='comment bubble'
                    />
                </div>
            </div>
            <img
                className='mx-auto my-12'
                src={`${process.env.PUBLIC_URL}/images/characters/character-header.png`}
                alt='unique characters you encounter on your journey'
            />
            {/* <HeaderTitle title="Unique characters you'll encounter on your journey" /> */}
            <div className='max-w-[1258px] w-full mx-auto px-4'>
                <div className='relative mx-auto h-0 w-full pt-[62.480127186%]'>
                    <a
                        onClick={() => {
                            ReactGA.event({
                                action: 'click',
                                event: 'link',
                                category: 'Character',
                                label: 'Rouen',
                            })
                        }}
                        href='#char-4'
                    >
                        <img
                            onMouseEnter={() => setHover(4)}
                            onMouseLeave={() => setHover(false)}
                            className='char4 hover:brightness-110 duration-300 cursor-pointer'
                            src={`${process.env.PUBLIC_URL}/images/characters/chr_nav_visual_04.png`}
                            alt='apricot kv'
                        />
                    </a>
                    {hover === 4 && (
                        <img
                            className='hidden md:block charinfo-4'
                            src={`${process.env.PUBLIC_URL}/images/characters/rouen-name.webp`}
                            alt='rouen'
                        />
                    )}
                    <img
                        className='block md:hidden charinfo-4'
                        src={`${process.env.PUBLIC_URL}/images/characters/rouen-name.webp`}
                        alt='rouen'
                    />
                    <a
                        onClick={() => {
                            ReactGA.event({
                                action: 'click',
                                event: 'link',
                                category: 'Character',
                                label: 'Henna',
                            })
                        }}
                        href='#char-5'
                    >
                        <img
                            onMouseEnter={() => setHover(5)}
                            onMouseLeave={() => setHover(false)}
                            className='char5 hover:brightness-110 duration-300 cursor-pointer'
                            src={`${process.env.PUBLIC_URL}/images/characters/chr_nav_visual_05.png`}
                            alt='apricot kv'
                        />
                    </a>
                    {hover === 5 && (
                        <img
                            className='hidden md:block charinfo-5'
                            src={`${process.env.PUBLIC_URL}/images/characters/henna-name.png`}
                            alt='henna'
                        />
                    )}{' '}
                    <img
                        className='block md:hidden charinfo-5'
                        src={`${process.env.PUBLIC_URL}/images/characters/henna-name.png`}
                        alt='henna'
                    />
                    <a
                        onClick={() => {
                            ReactGA.event({
                                action: 'click',
                                event: 'link',
                                category: 'Character',
                                label: 'Urumi',
                            })
                        }}
                        href='#char-6'
                    >
                        <img
                            onMouseEnter={() => setHover(6)}
                            onMouseLeave={() => setHover(false)}
                            className='char6 hover:brightness-110 duration-300 cursor-pointer'
                            src={`${process.env.PUBLIC_URL}/images/characters/chr_nav_visual_06.png`}
                            alt='urumi'
                        />
                    </a>
                    {hover === 6 && (
                        <img
                            className='hidden md:block charinfo-6'
                            src={`${process.env.PUBLIC_URL}/images/characters/urumi-name.webp`}
                            alt='urumi'
                        />
                    )}{' '}
                    <img
                        className='block md:hidden charinfo-6'
                        src={`${process.env.PUBLIC_URL}/images/characters/urumi-name.webp`}
                        alt='urumi'
                    />
                    <a
                        onClick={() => {
                            ReactGA.event({
                                action: 'click',
                                event: 'link',
                                category: 'Character',
                                label: 'Mayfair',
                            })
                        }}
                        href='#char-7'
                    >
                        <img
                            onMouseEnter={() => setHover(7)}
                            onMouseLeave={() => setHover(false)}
                            className='char7 hover:brightness-110 duration-300 cursor-pointer'
                            src={`${process.env.PUBLIC_URL}/images/characters/chr_nav_visual_07.png`}
                            alt='mayfair'
                        />
                    </a>
                    {hover === 7 && (
                        <img
                            className='charinfo-7'
                            src={`${process.env.PUBLIC_URL}/images/characters/mayfair-name.png`}
                            alt='mayfair'
                        />
                    )}{' '}
                    <img
                        className='block md:hidden charinfo-7'
                        src={`${process.env.PUBLIC_URL}/images/characters/mayfair-name.png`}
                        alt='mayfair'
                    />
                </div>
            </div>
            {chardata.map((chardata, i) => (
                <section id={`char-${i + 1}`} className='bg-char overflow-hidden'>
                    <div className='max-w-[1280px] lg:w-[80vw] flex flex-col align-middle md:flex-row md:items-end relative pt-8 mx-auto '>
                        <div className='w-full md:w-1/2 lg:w-[60%] mx-auto z-10'>
                            <div className='w-full md:w-4/5 mx-auto md:pt-12 '>
                                <div className='text-center'>
                                    <img
                                        className='max-w-full mx-auto text-center px-2 md:px-0'
                                        src={`${process.env.PUBLIC_URL}/images/characters/char-name-0${i + 1}.png`}
                                        alt={chardata.name}
                                    />{' '}
                                </div>
                                <div className='text-center md:text-left md:pt-12 flex flex-col md:flex-row justify-center  px-4 md:px-0 relative w-full mx-auto'>
                                    <div className={`character-description-0${i + 1} relative mb-12`}>
                                        {chardata.bio}

                                        <img
                                            onClick={() => {
                                                handleOpenModal(i + 1)
                                            }}
                                            className='mt-8 ss-thumb w-full max-w-[500px]'
                                            src={`${process.env.PUBLIC_URL}/images/ss/ss-char-${i + 1}-s.webp`}
                                            alt='game screenshot'
                                        />
                                    </div>
                                </div>{' '}
                            </div>
                        </div>{' '}
                        <div
                            className={`w-full md:w-1/2 lg:w-[40%] character-visual char-translate-y-${
                                i + 1
                            }   md:translate-y-0`}
                        >
                            <picture className={`character-bustup0${i + 1} bottom-0 `}>
                                <source
                                    srcSet={`${process.env.PUBLIC_URL}/images/characters/chr_visual_0${i + 1}_sp.png`}
                                    media='(max-width: 768px)'
                                ></source>
                                <img
                                    className=''
                                    src={`${process.env.PUBLIC_URL}/images/characters/chr_visual_0${i + 1}.png`}
                                    alt={chardata.name}
                                />{' '}
                            </picture>
                            <div>
                                <div className='absolute top-0 -translate-y-[1/2] lg:-translate-y-full left-1/2 -translate-x-1/2 w-4/5 lg:w-full text-center mx-auto'>
                                    {chardata.caption}
                                </div>

                                {voice === i + 1 && isVoiceOn === true ? (
                                    <button
                                        onClick={() => {
                                            setIsVoiceOn(false)
                                        }}
                                        className='ww-auto absolute right-[10vw] lg:right-0 bottom-8 lg:bottom-28'
                                    >
                                        <img
                                            className='w-[7vw] md:w-full  mx-auto'
                                            src={`${process.env.PUBLIC_URL}/images/btn_voice_off.png`}
                                            alt='voice off mark'
                                        />{' '}
                                    </button>
                                ) : (
                                    <button
                                        onClick={() => {
                                            setCurrent(i + 1)
                                            setIsVoiceOn(true)
                                        }}
                                        className='w-auto absolute right-[10vw] lg:right-0 bottom-8 lg:bottom-28'
                                    >
                                        <img
                                            className='w-[7vw] md:w-full mx-auto'
                                            src={`${process.env.PUBLIC_URL}/images/btn_voice.png`}
                                            alt='voice mark'
                                        />{' '}
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                </section>
            ))}
            <div
                onClick={handleCloseModal}
                className={`z-50 fixed top-0 left-0 w-full  h-full bg-black/80 ${showModal ? 'block' : 'hidden'}`}
            >
                <div
                    onClick={(e) => e.stopPropagation()}
                    className='w-[90%] md:w-[80%] absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2 mx-auto z-30'
                >
                    <div className='flex flex-row items-center max-w-[1920px] mx-auto md:gap-4'>
                        <div className='relative'>
                            <button
                                onClick={handleCloseModal}
                                className='absolute top-0 right-0 -translate-y-full translate-x-1/4 md:-translate-y-full md:translate-x-full'
                            >
                                <img className='' src={`${process.env.PUBLIC_URL}/images/close.png`} alt={`close`} />{' '}
                            </button>
                            <img
                                className='white-drop-shadow max-w-[1920px] mx-auto w-full'
                                src={`${process.env.PUBLIC_URL}/images/ss/ss-char-${modalImage}.webp`}
                                alt={`screen shot of game system`}
                            />{' '}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
